
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Brand`}</h1>
<p>{`If you want to have a look at all the constants (`}<inlineCode parentName="p">{`drylus-style-vars`}</inlineCode>{`) available in this design system, you can see them `}<a parentName="p" {...{
        "href": "brand/style-variables"
      }}>{`here`}</a>{`.`}</p>
<p>{`For all the colors available in the system, you can look at `}<a parentName="p" {...{
        "href": "brand/colors"
      }}>{`colors`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;